// File: vehicle-model-selector.js
// use in the vehicle-model-selector.liquid file

class VehicleModelSelector extends HTMLElement {
  constructor() {
    super();
    this.mql = window.matchMedia('(min-width: 750px)');
    this.elements = {
      vehicleButton: this.querySelector('.disclosure__button'),
      vehiclePanel: this.querySelector('.disclosure__list-wrapper'),
      search: this.querySelector('input[name="vehicle_filter"]'),
      closeButton: this.querySelector('.vehicle-filter__reset-button'),
      vehicleOptions: this.querySelectorAll('#vehicle-model-list .disclosure__item button'),
    };
    this.addEventListeners();
    this.hideAll();
  }

  addEventListeners() {
    this.elements.vehicleButton.addEventListener('click', this.toggleSelector.bind(this, 'vehicle'));

    this.elements.vehicleOptions.forEach((option) => {
      option.addEventListener('click', this.onVehicleItemClick.bind(this));
    });

    if (this.elements.search) {
      this.elements.search.addEventListener('keyup', this.filterOptions.bind(this));
      this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
    }

    if (this.elements.closeButton) {
      this.elements.closeButton.addEventListener('click', this.closeModal.bind(this));
    }

    document.addEventListener('click', this.handleOutsideClick.bind(this));

    // Adding hover listeners for specification and marker elements
    this.addHoverListeners();
  }

  addHoverListeners() {
    const markerElements = document.querySelectorAll('.marker__container');
    const specificationItems = document.querySelectorAll('.specification');

    markerElements.forEach((marker) => {
      marker.addEventListener('mouseenter', this.onMarkerHover.bind(this));
      marker.addEventListener('mouseleave', this.onMarkerHover.bind(this));
    });

    specificationItems.forEach((item) => {
      item.addEventListener('mouseenter', this.onSpecificationHover.bind(this));
      item.addEventListener('mouseleave', this.onSpecificationHover.bind(this));
    });
  }

  onVehicleItemClick(event) {
    const target = event.target;
    const selectedValue = target.dataset.value.trim();
    this.elements.vehicleButton.querySelector('span').textContent = target.textContent;
    this.updateSpecificationDisplay(selectedValue);
    this.hidePanel('vehicle');
  }

  updateSpecificationDisplay(selectedValue) {
    const handleizedValue = this.handleize(selectedValue);
    const allSpecs = document.querySelectorAll('.vehicle-specifications');
    const allMarkers = document.querySelectorAll('.marker__container');

    if (!allSpecs || allSpecs.length === 0) {
      console.warn('No specification elements found');
      return;
    }

    allSpecs.forEach((element) => {
      const vehicleValue = element.dataset.vehicle;
      element.style.display = this.handleize(vehicleValue) === handleizedValue ? 'block' : 'none';
    });

    allMarkers.forEach((element) => {
      const vehicleValue = element.dataset.vehicle;
      element.style.display = this.handleize(vehicleValue) === handleizedValue ? 'block' : 'none';
    });

    const tablinks = document.getElementById('product-specs-tabs');
    if (tablinks) {
      tablinks.style.display = 'block';
    }

    // Re-add event listeners for the newly displayed elements
    this.addHoverListeners();
  }

  onMarkerHover(event) {
    const markerWrapper = event.currentTarget.closest('.marker__wrapper');
    const marker = markerWrapper.querySelector('.marker');
    const targetId = markerWrapper.dataset.targetId;

    if (!targetId) {
      console.log('No target ID found');
      return;
    }

    const specItem = document.querySelector(`.specification[data-target-id="${targetId}"]`);

    if (specItem) {
      specItem.classList.toggle('specification-highlight', event.type === 'mouseenter');
      marker.classList.toggle('marker-highlight', event.type === 'mouseenter');
    }
  }

  onSpecificationHover(event) {
    const specItem = event.currentTarget;
    const targetId = specItem.dataset.targetId;

    if (!targetId) {
      console.log('No target ID found');
      return;
    }

    const markerWrapper = document.querySelector(`.marker__wrapper[data-target-id="${targetId}"]`);
    const marker = markerWrapper ? markerWrapper.querySelector('.marker') : null;

    if (marker) {
      marker.classList.toggle('marker-highlight', event.type === 'mouseenter');
      specItem.classList.toggle('specification-highlight', event.type === 'mouseenter');
    }
  }

  handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }

  toggleSelector(type, event) {
    if (event) {
      event.stopPropagation();
    }
    const button = this.elements.vehicleButton;
    const panel = this.elements.vehiclePanel;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    panel.toggleAttribute('hidden', isExpanded);
    button.setAttribute('aria-expanded', !isExpanded);

    if (!isExpanded && type === 'vehicle' && this.elements.search && this.mql.matches) {
      this.elements.search.focus();
    }
  }

  hidePanel(type) {
    const button = this.elements.vehicleButton;
    const panel = this.elements.vehiclePanel;
    button.setAttribute('aria-expanded', 'false');
    panel.setAttribute('hidden', true);
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel('vehicle');
    }
  }

  filterOptions() {
    const searchValue = this.elements.search.value.toLowerCase().trim();
    const searchRegex = new RegExp(searchValue, 'i');
    const options = this.querySelectorAll('.disclosure__item');

    options.forEach((option) => {
      const optionLink = option.querySelector('button.disclosure__link');
      const optionText = optionLink.textContent.toLowerCase().trim();
      option.style.display = searchRegex.test(optionText) ? '' : 'none';
    });
  }
}

customElements.define('vehicle-model-selector', VehicleModelSelector);